export const gatewayListMapping = (data) => {
    const filters = data?.paginatedData?.filters || data?.filters || {};

    const mapItem = (item) => ({
        key: item.id,
        id: item.id,
        ...item,
    });

    if (data && data.paginatedData) {
        return {
            paginatedData: {
                ...data.paginatedData,
                items: data.paginatedData.items ? data.paginatedData.items.map(mapItem) : [],
            },
            filters,
            sortableColumns: data.paginatedData.sortableColumns || [],
        };
    }

    return {
        paginatedData: {
            items: data.items ? data.items.map(mapItem) : [],
            page: data.page,
            size: data.size,
            totalRecords: data.totalRecords,
            totalFilteredRecords: data.totalFilteredRecords,
        },
        filters,
        sortableColumns: data.sortableColumns || [],
    };
};

const buildGatewayRequest = (values) => {
    const {id, name, description, statsInterval, longitude, latitude} = values || {};

    const mappedValues = {
        id,
        name,
        description,
        statsInterval: parseInt(statsInterval, 10),
        longitude: parseFloat(longitude),
        latitude: parseFloat(latitude),
    };

    return mappedValues;
};

export const createGatewayRequestMapping = (values) => {
    return buildGatewayRequest(values);
};

export const editGatewayRequestMapping = (values) => {
    return buildGatewayRequest(values);
};
